import { render, staticRenderFns } from "./LockerInformationHeader.vue?vue&type=template&id=80fc1440&"
import script from "./LockerInformationHeader.vue?vue&type=script&lang=js&"
export * from "./LockerInformationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports